import React from "react";
import { Button, Checkbox, Form, Input } from "antd";
import alertUtils from "@/utils/alert";
import authAPI from "@/services/auth_api";
import { FieldNamesType } from "antd/es/cascader";
import { IPassword } from "@/types/constants";
import { definitions } from "@/services/metruyenvl";

function ChangePassword({ user }: { user: definitions["do.UserDO"] }) {
    const [form] = Form.useForm();
    const onFinish = (values: any) => {
        console.log("ChangePassword Success:", values);
        handleChange(values);
        form.resetFields();
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };
    const handleChange = async (data: IPassword) => {
        try {
            const res = await authAPI.changePassword(data);
            alertUtils.toastSuccess("Đổi mật khẩu thành công!");
        } catch (error: any) {
            console.log(error.response.data);
        }
    };
    return (
        <div>
            <Form form={form} name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} style={{ maxWidth: 600 }} initialValues={{ remember: true }} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
                <Form.Item
                    label="Mật khẩu hiện tại"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập mật khẩu cũ!",
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Mật khẩu mới"
                    name="new_password"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập mật khẩu mới!",
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Xác nhận mật khẩu mới"
                    name="confirm_new_password"
                    dependencies={["new_password"]}
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng xác nhận mật khẩu!",
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("new_password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Xác nhận mật khẩu không trùng khớp!"));
                            },
                        }),
                    ]}
                >
                    <Input.Password allowClear />
                </Form.Item>

                <button className="float-right mt-4 mb-4 bg-orange-400 rounded-lg p-2 text-white font-semibold">Cập nhật</button>
            </Form>
        </div>
    );
}

export default ChangePassword;
